<template>
  <TModal
    v-if="showModal"
    :header="filteredMergeTags.singularTitle"
    xs
    header-low
    no-min-height
    id="tiptap-mt-modal"
    :inverse="inverse"
    @close="closeModal"
  >
    <template #dialog-body>
      <div class="px-5 tiptap-link-modal">
        <div class="gap-2 flex items-end">
          <TInput
            v-model="localValue"
            placeholder="Enter merge tag"
            class="box-border"
            :inverse="inverse"
          />
          <MergetagDropdown
            v-if="mergeTags"
            :merge-tags="filteredMergeTags"
            no-default-select
            :inverse="inverse"
            @select="selectItem"
          />
        </div>
      </div>
    </template>
    <template #dialog-footer>
      <div class="px-5 py-5 flex justify-end">
        <TButton success @click="onOkButtonClick">Update</TButton>
      </div>
    </template>
  </TModal>
</template>

<script setup lang="ts">
import { TInput, TModal, TButton } from "@topol/twig-ui";
import { ref, computed } from "vue";
import IEditorConfig from "../../../types/IEditorConfig";
import MergetagDropdown from "./MergetagDropdown.vue";
import { filterFullMergeTags } from "./filterMergeTags";

const props = defineProps<{
  mergeTags: Exclude<IEditorConfig["mergeTags"], undefined>;
  inverse?: boolean;
}>();

const showModal = ref(false);
const resolveLocal = ref<any>();
const localValue = ref("");

const filteredMergeTags = computed(() => {
  return {
    ...props.mergeTags,
    mergeTags: filterFullMergeTags(
      props.mergeTags.mergeTags,
      props.mergeTags.syntax
    ),
  };
});

async function openModal(oldTag: string) {
  return new Promise<string>((res) => {
    resolveLocal.value = res;
    localValue.value = oldTag;
    showModal.value = true;
  });
}

function selectItem(item: { value: string; label: string }) {
  localValue.value = item.value;
}

const onOkButtonClick = () => {
  showModal.value = false;
  resolveLocal.value(localValue.value);
};

const closeModal = () => {
  showModal.value = false;
  resolveLocal.value(false);
};

defineExpose({
  openModal,
});
</script>
